<template>
	<ButtonsDropdownTab :canCreateNew="canCreateNew" @show-wizard="showWizard" :page="page" :idsToShow="idsToShow" :filterBy="filterBy" />
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import ButtonsDropdownTab from '@/views/AppContentPages/ButtonsDropdownTab.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { VIRTUAL_PROJECT_IDS, PROJECTS_SHARED_WITH_ME_VIRTUAL_ID } from '@/utils/projects.const';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
import { CREATION_MODES } from '@/components/CreationWizard/creation-wizard.const';
export default {
	name: 'SpaceButtonsDropdownDataProvider',
	props: {
		idsToShow: { type: Array },
		page: { type: Number, default: 1 },
	},
	components: { ButtonsDropdownTab },
	computed: {
		...mapGettersShorthand({ selectedProjectId, projectHasPermission }),
		filterBy() {
			if (this.selectedProjectId && !VIRTUAL_PROJECT_IDS.includes(this.selectedProjectId)) {
				return { project: this.selectedProjectId };
			}
			if (PROJECTS_SHARED_WITH_ME_VIRTUAL_ID === this.selectedProjectId) {
				return { shared_with_me: true }; // if we set false we actually request to exclude the projects shared with me
			}
			return null;
		},
		canCreateNew() {
			if (this.projectToCreateWorkflowIn) {
				return this.projectHasPermission(this.selectedProjectId, ProjectPermissions.ManageButtonDropdowns);
			}
			return true;
		},
		projectToCreateWorkflowIn() {
			return VIRTUAL_PROJECT_IDS.includes(this.selectedProjectId) ? undefined : Number(this.selectedProjectId);
		},
	},
	methods: {
		showWizard() {
			AppDialogManagerService.openCreationWizardDialog({
				initialState: { projectId: this.projectToCreateWorkflowIn },
				mode: CREATION_MODES.BUTTON_DROPDOWN,
			});
		},
	},
};
</script>
<style scoped lang="scss"></style>
